import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { API_ROUTES } from '../../util/route.constants';
import { LICAuthResponse } from '../../models/lic.interface';

@Injectable({
  providedIn: 'root',
})
export class LicServiceService {
  constructor(private readonly http: HttpClient) { }

  getLicAuthentication(body: { licToken: string; practitionerId: string }) {
    const url = `${environment.user_management_api_url}${API_ROUTES.LIC_LOGIN}`;
    return this.http.post<LICAuthResponse>(url, body);
  }
}